import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ScrollTop from "react-scrolltop-button";

import { Box, Tabs, Tab, Typography } from "@mui/material";
import { ArrowDropUp } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import MachineMaintenanceSummaryList from "./MachineMaintenanceSummaryList";
import MachineMaintenanceSummaryListPlanned from "./MachineMaintenanceSummaryListPlanned";
import { getTitle } from "../../common";

export default function Lists() {
    const ls = localStorage;
    const theme = useTheme();
    const [value, setValue] = useState(0);
    const { t } = useTranslation("translation");

    const TabPanel = (props) => {
        const { children, value, index, ...other } = props;

        return (
            <Typography component="div" role="tabpanel" hidden={value !== index} id={`scrollable-auto-tabpanel-${index}`} aria-labelledby={`scrollable-auto-tab-${index}`} {...other}>
                <Box>{children}</Box>
            </Typography>
        );
    };

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const a11yProps = (index) => {
        return {
            id: `scrollable-auto-tab-${index}`,
            "aria-controls": `scrollable-auto-tabpanel-${index}`,
        };
    };

    return (
        <div>
            <Box sx={{ width: "100%" }}>
            {getTitle(t("MachineMaintenanceSummaryList"))}
                <Tabs value={value} onChange={handleChange} centered>
                    <Tab label={t("UnplannedTask")} {...a11yProps(0)}></Tab>
                    <Tab label={t("Planned")} {...a11yProps(1)}></Tab>
                </Tabs>
            </Box>
            {/* <SwipeableViews
          axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
          index={value}
          onChangeIndex={value => {setValue(value)}}
          enableMouseEvents
        > */}
            <TabPanel value={value} index={0} dir={theme.direction}>
                {value == 0 ? <MachineMaintenanceSummaryList /> : null}
            </TabPanel>
            <TabPanel value={value} index={1} dir={theme.direction}>
                {value == 1 ? <MachineMaintenanceSummaryListPlanned /> : null}
            </TabPanel>
            {/* </SwipeableViews> */}

            <ScrollTop
                text="▲"
                distance={100}
                breakpoint={2000}
                style={{ backgroundColor: "#BCC5C6", borderRadius: "20px", border: "2px", color: "black" }}
                speed={200}
                target={0}
                number={10}
                icon={<ArrowDropUp />}
            />
        </div>
    );
}
